module.exports = __webpack_public_path__ + "media/images/products/template/01/08-cf7b0dd044e25bea2a32481e1f1c4b72.jpg";